import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { useNavigate } from 'react-router';
import {Snackprovider} from '../../hooks/useSnackbar'

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { AppBar, Box, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';

// project imports
import Breadcrumbs from 'ui-component/extended/Breadcrumbs';
import Header from './Header';
import Sidebar from './Sidebar';
import Customization from '../Customization';
import navigation from 'menu-items';
import { drawerWidth } from 'store/constant';
import { SET_MENU } from 'store/actions';

// assets
import { IconChevronRight } from '@tabler/icons';
import { auth, db } from 'index';

import { collection, CollectionReference, where, query, doc, setDoc, getDocs, addDoc, serverTimestamp } from '@firebase/firestore';


// styles
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open, fullScreen }) => ({
    ...theme.typography.mainContent,
    ...(!open && {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('md')]: {
           marginLeft: fullScreen!=undefined ? '0px': -(drawerWidth ),
            width: fullScreen!=undefined ?'100%':`calc(100% - ${drawerWidth}px)`
        },
        [theme.breakpoints.down('md')]: {
            width: fullScreen!=undefined ?'100%':`calc(100% - ${drawerWidth}px)`,
            padding: '16px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px',
            width: fullScreen!=undefined ?'100%':`calc(100% - ${drawerWidth}px)`,
            padding: '16px',
           
        }
    }),
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        width: fullScreen!=undefined ?'100%':`calc(100% - ${drawerWidth}px)`,
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px'
        }
    })
}));

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
    
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('lg'));
    const navigate=useNavigate()

    // Handle left drawer
    const leftDrawerOpened = useSelector((state) => state.customization.opened);
    const dispatch = useDispatch();
    const handleLeftDrawerToggle = () => {
        dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
    };
    auth.onAuthStateChanged(user => {
        if (!user) {
            navigate('/login');   
        }
    }
    )
    useEffect(() => {
        dispatch({ type: SET_MENU, opened: !matchDownMd });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchDownMd]);

    return (
        <Snackprovider>
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            
            {/* header */}
            <AppBar
                enableColorOnDark
                position="fixed"
                color="inherit"
                elevation={0}
                sx={{
                    bgcolor: theme.palette.background.default,
                    transition: leftDrawerOpened ? theme.transitions.create('width') : 'none'
                }}
            >   
                <Toolbar sx={{boxShadow:'0 0.5rem 1rem 0 rgba(44,51,73,.1)'}}>
                
                    <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
                </Toolbar>
            </AppBar>

            {/* drawer */}
            <Sidebar drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} />

            {/* main content */}
            <Main theme={theme} open={leftDrawerOpened}  sx={{
                    transition: leftDrawerOpened ? theme.transitions.create('width') : 'none',
                    marginRight:'0px',
                    borderRadius:'0px',
                    marginTop:'75px',
                    paddingTop:'30px',
                    minHeight:'100vh'
                    
                }}>
                {/* breadcrumb */}
                <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title rightAlign />
                <Outlet />
            </Main>
            <Customization />
        </Box>
        </Snackprovider>
    );
};
const FullscreenLayout = () => {
    
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('lg'));
    const navigate=useNavigate()

    // Handle left drawer
    const leftDrawerOpened = useSelector((state) => !state.customization.opened);
    const dispatch = useDispatch();
    const handleLeftDrawerToggle = () => {
        dispatch({ type: SET_MENU, opened: leftDrawerOpened });
    };
    auth.onAuthStateChanged(user => {
        if (!user) {
            navigate('/login');   
        }
    }
    )
    useEffect(() => {
        dispatch({ type: SET_MENU, opened: !matchDownMd });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchDownMd]);

    return (
        <Snackprovider>
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            
            {/* header */}
            <AppBar
                enableColorOnDark
                position="fixed"
                color="inherit"
                elevation={0}
                sx={{
                    bgcolor: theme.palette.background.default,
                    transition: leftDrawerOpened ? theme.transitions.create('width') : 'none'
                }}
            >   
                <Toolbar sx={{boxShadow:'0 0.5rem 1rem 0 rgba(44,51,73,.1)'}}>
                
                    <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
                </Toolbar>
            </AppBar>

            {/* drawer */}
            <Sidebar drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} fullscreen={true} />
            <div style={{width:'100%',height:'100%', position:'absolute',backgroundColor:'#00000078', display:leftDrawerOpened?'block':'none'}}></div>
            {/* main content */}
            <Main theme={theme} open={leftDrawerOpened} fullScreen={true} sx={{
                
                    marginRight:'0px',
                    borderRadius:'0px',
                    marginTop:'75px',
                    paddingTop:'30px',
                    maxHeight:'100vh',
                    position:'absolute',
                    zIndex:-1
                }}>
                {/* breadcrumb */}
                <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title rightAlign />
                <Outlet />
            </Main>
            <Customization />
        </Box>
        </Snackprovider>
    );
};

export default MainLayout;
export {FullscreenLayout}